import { Api as api } from "../../api";
const prefix = "/transport-resource";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    transportResourceServiceV1GetVendors: build.query<
      TransportResourceServiceV1GetVendorsApiResponse,
      TransportResourceServiceV1GetVendorsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/vendors`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          search: queryArg.search,
          status: queryArg.status,
          sort_by: queryArg.sortBy,
          order: queryArg.order,
          search_by: queryArg.searchBy,
        },
      }),
      providesTags: [{ type: "Vendor", id: "LIST" }],
    }),
    transportResourceServiceV1BulkDeleteVendor: build.mutation<
      TransportResourceServiceV1BulkDeleteVendorApiResponse,
      TransportResourceServiceV1BulkDeleteVendorApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/vendors`,
        method: "DELETE",
        params: {
          ids: queryArg.ids,
        },
      }),
      invalidatesTags: [{ type: "Vendor", id: "LIST" }],
    }),
    transportResourceServiceV1BulkUpdateVendorStatus: build.mutation<
      TransportResourceServiceV1BulkUpdateVendorStatusApiResponse,
      TransportResourceServiceV1BulkUpdateVendorStatusApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/vendors/status`,
        method: "PATCH",
        body: queryArg.transportResourceBulkUpdateVendorStatusReq,
      }),
      invalidatesTags: [{ type: "Vendor", id: "LIST" }],
    }),
    transportResourceServiceV1GetVendorDetail: build.query<
      TransportResourceServiceV1GetVendorDetailApiResponse,
      TransportResourceServiceV1GetVendorDetailApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/api/v1/vendors/${queryArg.id}` }),
    }),
    transportResourceServiceV1UploadVendorLogo: build.mutation<
      TransportResourceServiceV1UploadVendorLogoApiResponse,
      TransportResourceServiceV1UploadVendorLogoApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/vendors/${queryArg.id}/upload-logo`,
        method: "POST",
        body: queryArg.transportResourceServiceV1UploadVendorLogoBody,
      }),
    }),
    transportResourceServiceV1CreateVendorAddress: build.mutation<
      TransportResourceServiceV1CreateVendorAddressApiResponse,
      TransportResourceServiceV1CreateVendorAddressApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/vendors/${queryArg.vendorId}/addresses`,
        method: "POST",
        body: queryArg.transportResourceServiceV1CreateVendorAddressBody,
      }),
    }),
    transportResourceServiceV1DeleteVendorAddress: build.mutation<
      TransportResourceServiceV1DeleteVendorAddressApiResponse,
      TransportResourceServiceV1DeleteVendorAddressApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/vendors/${queryArg.vendorId}/addresses/${queryArg.addressId}`,
        method: "DELETE",
      }),
    }),
    transportResourceServiceV1UpdateVendorAddress: build.mutation<
      TransportResourceServiceV1UpdateVendorAddressApiResponse,
      TransportResourceServiceV1UpdateVendorAddressApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/vendors/${queryArg.vendorId}/addresses/${queryArg.addressId}`,
        method: "PATCH",
        body: queryArg.transportResourceServiceV1UpdateVendorAddressBody,
      }),
    }),
    transportResourceServiceV1CreateVendorBranch: build.mutation<
      TransportResourceServiceV1CreateVendorBranchApiResponse,
      TransportResourceServiceV1CreateVendorBranchApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/vendors/${queryArg.vendorId}/branches`,
        method: "POST",
        body: queryArg.transportResourceServiceV1CreateVendorBranchBody,
      }),
    }),
    transportResourceServiceV1DeleteVendorBranch: build.mutation<
      TransportResourceServiceV1DeleteVendorBranchApiResponse,
      TransportResourceServiceV1DeleteVendorBranchApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/vendors/${queryArg.vendorId}/branches/${queryArg.branchId}`,
        method: "DELETE",
      }),
    }),
    transportResourceServiceV1UpdateVendorBranch: build.mutation<
      TransportResourceServiceV1UpdateVendorBranchApiResponse,
      TransportResourceServiceV1UpdateVendorBranchApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/api/v1/vendors/${queryArg.vendorId}/branches/${queryArg.branchId}`,
        method: "PATCH",
        body: queryArg.transportResourceServiceV1UpdateVendorBranchBody,
      }),
    }),
    transportResourceServiceV1CreateVendor: build.mutation<
      TransportResourceServiceV1CreateVendorApiResponse,
      TransportResourceServiceV1CreateVendorApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vendors/create`,
        method: "POST",
        body: queryArg.transportResourceCreateVendorReq,
      }),
      invalidatesTags: [{ type: "Vendor", id: "LIST" }],
    }),
    transportResourceServiceV1ListVendorDrafts: build.query<
      TransportResourceServiceV1ListVendorDraftsApiResponse,
      TransportResourceServiceV1ListVendorDraftsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vendors/draft`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          order: queryArg.order,
        },
      }),
      providesTags: [{ type: "Vendor", id: "DRAFT_LIST" }],
    }),
    transportResourceServiceV1CreateVendorDraft: build.mutation<
      TransportResourceServiceV1CreateVendorDraftApiResponse,
      TransportResourceServiceV1CreateVendorDraftApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vendors/draft`,
        method: "POST",
        body: queryArg.transportResourceCreateVendorDraftReq,
      }),
      invalidatesTags: [{ type: "Vendor", id: "DRAFT_LIST" }],
    }),
    transportResourceServiceV1GetVendorDraft: build.query<
      TransportResourceServiceV1GetVendorDraftApiResponse,
      TransportResourceServiceV1GetVendorDraftApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/vendors/draft/${queryArg.id}` }),
    }),
    transportResourceServiceV1DeleteVendorDraft: build.mutation<
      TransportResourceServiceV1DeleteVendorDraftApiResponse,
      TransportResourceServiceV1DeleteVendorDraftApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vendors/draft/${queryArg.id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Vendor", id: "DRAFT_LIST" }],
    }),
    transportResourceServiceV1UpdateVendorDraft: build.mutation<
      TransportResourceServiceV1UpdateVendorDraftApiResponse,
      TransportResourceServiceV1UpdateVendorDraftApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vendors/draft/${queryArg.id}`,
        method: "PUT",
        body: queryArg.transportResourceServiceV1UpdateVendorDraftBody,
      }),
      invalidatesTags: [{ type: "Vendor", id: "DRAFT_LIST" }],
    }),
    transportResourceServiceV1PublishVendorDraft: build.mutation<
      TransportResourceServiceV1PublishVendorDraftApiResponse,
      TransportResourceServiceV1PublishVendorDraftApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vendors/draft/${queryArg.id}/publish`,
        method: "POST",
        body: queryArg.transportResourceServiceV1PublishVendorDraftBody,
      }),
      invalidatesTags: [{ type: "Vendor", id: "LIST" }, { type: "Vendor", id: "DRAFT_LIST" }],
    }),
    transportResourceServiceV1ExportVendors: build.mutation<
      Blob,
      TransportResourceServiceV1ExportVendorsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vendors/export`,
        method: "POST",
        body: queryArg.transportResourceExportVendorsReq,
        responseHandler: (response) =>
          response.ok ? response.blob() : response.json(),
      }),
    }),
    transportResourceServiceV1ImportVendor: build.mutation<
      TransportResourceServiceV1ImportVendorApiResponse,
      TransportResourceServiceV1ImportVendorApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vendors/import`,
        method: "POST",
        body: queryArg.apiHttpBody,
      }),
      invalidatesTags: [{ type: "Vendor", id: "LIST" }],
    }),
    transportResourceServiceV1DownloadVendorImportTemplate: build.query<
      TransportResourceServiceV1DownloadVendorImportTemplateApiResponse,
      TransportResourceServiceV1DownloadVendorImportTemplateApiArg
    >({
      query: () => ({ url: `${prefix}/v1/vendors/import/template` }),
    }),
    transportResourceServiceV1UpdateVendor: build.mutation<
      TransportResourceServiceV1UpdateVendorApiResponse,
      TransportResourceServiceV1UpdateVendorApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vendors/${queryArg.id}`,
        method: "PUT",
        body: queryArg.transportResourceServiceV1UpdateVendorBody,
      }),
      invalidatesTags: [{ type: "Vendor", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as vendorApi };
export type TransportResourceServiceV1GetVendorsApiResponse =
  /** status 200 A successful response. */ TransportResourceGetVendorsRes;
export type TransportResourceServiceV1GetVendorsApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  sortBy?: string;
  order?: string;
  searchBy?: string;
};
export type TransportResourceServiceV1BulkDeleteVendorApiResponse =
  /** status 200 A successful response. */ TransportResourceBulkDeleteVendorRes;
export type TransportResourceServiceV1BulkDeleteVendorApiArg = {
  ids: string[];
};
export type TransportResourceServiceV1BulkUpdateVendorStatusApiResponse =
  /** status 200 A successful response. */ TransportResourceBulkUpdateVendorStatusRes;
export type TransportResourceServiceV1BulkUpdateVendorStatusApiArg = {
  transportResourceBulkUpdateVendorStatusReq: TransportResourceBulkUpdateVendorStatusReq;
};
export type TransportResourceServiceV1GetVendorDetailApiResponse =
  /** status 200 A successful response. */ TransportResourceGetVendorDetailRes;
export type TransportResourceServiceV1GetVendorDetailApiArg = {
  id: string;
};
export type TransportResourceServiceV1UploadVendorLogoApiResponse =
  /** status 200 A successful response. */ TransportResourceUploadVendorLogoRes;
export type TransportResourceServiceV1UploadVendorLogoApiArg = {
  id: string;
  transportResourceServiceV1UploadVendorLogoBody: TransportResourceServiceV1UploadVendorLogoBody;
};
export type TransportResourceServiceV1CreateVendorAddressApiResponse =
  /** status 200 A successful response. */ TransportResourceVendorMessageRes;
export type TransportResourceServiceV1CreateVendorAddressApiArg = {
  vendorId: string;
  transportResourceServiceV1CreateVendorAddressBody: TransportResourceServiceV1CreateVendorAddressBody;
};
export type TransportResourceServiceV1DeleteVendorAddressApiResponse =
  /** status 200 A successful response. */ TransportResourceVendorMessageRes;
export type TransportResourceServiceV1DeleteVendorAddressApiArg = {
  vendorId: string;
  addressId: string;
};
export type TransportResourceServiceV1UpdateVendorAddressApiResponse =
  /** status 200 A successful response. */ TransportResourceVendorMessageRes;
export type TransportResourceServiceV1UpdateVendorAddressApiArg = {
  vendorId: string;
  addressId: string;
  transportResourceServiceV1UpdateVendorAddressBody: TransportResourceServiceV1UpdateVendorAddressBody;
};
export type TransportResourceServiceV1CreateVendorBranchApiResponse =
  /** status 200 A successful response. */ TransportResourceVendorMessageRes;
export type TransportResourceServiceV1CreateVendorBranchApiArg = {
  vendorId: string;
  transportResourceServiceV1CreateVendorBranchBody: TransportResourceServiceV1CreateVendorBranchBody;
};
export type TransportResourceServiceV1DeleteVendorBranchApiResponse =
  /** status 200 A successful response. */ TransportResourceVendorMessageRes;
export type TransportResourceServiceV1DeleteVendorBranchApiArg = {
  vendorId: string;
  branchId: string;
};
export type TransportResourceServiceV1UpdateVendorBranchApiResponse =
  /** status 200 A successful response. */ TransportResourceVendorMessageRes;
export type TransportResourceServiceV1UpdateVendorBranchApiArg = {
  vendorId: string;
  branchId: string;
  transportResourceServiceV1UpdateVendorBranchBody: TransportResourceServiceV1UpdateVendorBranchBody;
};
export type TransportResourceServiceV1CreateVendorApiResponse =
  /** status 200 A successful response. */ TransportResourceCreateVendorRes;
export type TransportResourceServiceV1CreateVendorApiArg = {
  transportResourceCreateVendorReq: TransportResourceCreateVendorReq;
};
export type TransportResourceServiceV1ListVendorDraftsApiResponse =
  /** status 200 A successful response. */ TransportResourceGetVendorsRes;
export type TransportResourceServiceV1ListVendorDraftsApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  order?: string;
};
export type TransportResourceServiceV1CreateVendorDraftApiResponse =
  /** status 200 A successful response. */ TransportResourceCreateVendorDraftRes;
export type TransportResourceServiceV1CreateVendorDraftApiArg = {
  transportResourceCreateVendorDraftReq: TransportResourceCreateVendorDraftReq;
};
export type TransportResourceServiceV1GetVendorDraftApiResponse =
  /** status 200 A successful response. */ TransportResourceGetVendorDetailRes;
export type TransportResourceServiceV1GetVendorDraftApiArg = {
  id: string;
};
export type TransportResourceServiceV1DeleteVendorDraftApiResponse =
  /** status 200 A successful response. */ TransportResourceDeleteVendorDraftRes;
export type TransportResourceServiceV1DeleteVendorDraftApiArg = {
  id: string;
};
export type TransportResourceServiceV1UpdateVendorDraftApiResponse =
  /** status 200 A successful response. */ TransportResourceUpdateVendorDraftRes;
export type TransportResourceServiceV1UpdateVendorDraftApiArg = {
  id: string;
  transportResourceServiceV1UpdateVendorDraftBody: TransportResourceServiceV1UpdateVendorDraftBody;
};
export type TransportResourceServiceV1PublishVendorDraftApiResponse =
  /** status 200 A successful response. */ TransportResourcePublishVendorDraftRes;
export type TransportResourceServiceV1PublishVendorDraftApiArg = {
  id: string;
  transportResourceServiceV1PublishVendorDraftBody: TransportResourceServiceV1PublishVendorDraftBody;
};
export type TransportResourceServiceV1ExportVendorsApiResponse =
  /** status 200 A successful response. */ ApiHttpBody;
export type TransportResourceServiceV1ExportVendorsApiArg = {
  transportResourceExportVendorsReq: TransportResourceExportVendorsReq;
};
export type TransportResourceServiceV1ImportVendorApiResponse =
  /** status 200 Vendor imported successfully */ TransportResourceImportVendorRes;
export type TransportResourceServiceV1ImportVendorApiArg = {
  /** Message that represents an arbitrary HTTP body. It should only be used for
    payload formats that can't be represented as JSON, such as raw binary or
    an HTML page.
    
    
    This message can be used both in streaming and non-streaming API methods in
    the request as well as the response.
    
    It can be used as a top-level request field, which is convenient if one
    wants to extract parameters from either the URL or HTTP template into the
    request fields and also want access to the raw HTTP body.
    
    Example:
    
        message GetResourceRequest {
          // A unique request id.
          string request_id = 1;
    
          // The raw HTTP body is bound to this field.
          google.api.HttpBody http_body = 2;
    
        }
    
        service ResourceService {
          rpc GetResource(GetResourceRequest)
            returns (google.api.HttpBody);
          rpc UpdateResource(google.api.HttpBody)
            returns (google.protobuf.Empty);
    
        }
    
    Example with streaming methods:
    
        service CaldavService {
          rpc GetCalendar(stream google.api.HttpBody)
            returns (stream google.api.HttpBody);
          rpc UpdateCalendar(stream google.api.HttpBody)
            returns (stream google.api.HttpBody);
    
        }
    
    Use of this type only changes how the request and response bodies are
    handled, all other features will continue to work unchanged. */
  apiHttpBody: ApiHttpBody;
};
export type TransportResourceServiceV1DownloadVendorImportTemplateApiResponse =
  unknown;
export type TransportResourceServiceV1DownloadVendorImportTemplateApiArg = void;
export type TransportResourceServiceV1UpdateVendorApiResponse =
  /** status 200 A successful response. */ TransportResourceUpdateVendorRes;
export type TransportResourceServiceV1UpdateVendorApiArg = {
  id: string;
  transportResourceServiceV1UpdateVendorBody: TransportResourceServiceV1UpdateVendorBody;
};
export type TransportResourceVendorActor = {
  id?: string;
  name?: string;
  timestamp?: string;
};
export type TransportResourceVendorListItem = {
  id?: string;
  name?: string;
  code?: string;
  legal_name?: string;
  phone?: string;
  email?: string;
  contact_person_name?: string;
  contact_person_phone_number?: string;
  vendor_logo?: string;
  registered_fleet?: number;
  status?: string;
  created_by?: TransportResourceVendorActor;
  updated_by?: TransportResourceVendorActor;
};
export type TransportResourceVendorListMeta = {
  current_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
  limit?: number;
  total?: number;
  total_page?: number;
};
export type TransportResourceGetVendorsRes = {
  vendor?: TransportResourceVendorListItem[];
  metadata?: TransportResourceVendorListMeta;
};
export type ProtobufAny = {
  /** Identifies the type of the serialized Protobuf message with a URI reference
    consisting of a prefix ending in a slash and the fully-qualified type name.
    
    Example: type.googleapis.com/google.protobuf.StringValue
    
    This string must contain at least one `/` character, and the content after
    the last `/` must be the fully-qualified name of the type in canonical
    form, without a leading dot. Do not write a scheme on these URI references
    so that clients do not attempt to contact them.
    
    The prefix is arbitrary and Protobuf implementations are expected to
    simply strip off everything up to and including the last `/` to identify
    the type. `type.googleapis.com/` is a common default prefix that some
    legacy implementations require. This prefix does not indicate the origin of
    the type, and URIs containing it are not expected to respond to any
    requests.
    
    All type URL strings must be legal URI references with the additional
    restriction (for the text format) that the content of the reference
    must consist only of alphanumeric characters, percent-encoded escapes, and
    characters in the following set (not including the outer backticks):
    `/-.~_!$&()*+,;=`. Despite our allowing percent encodings, implementations
    should not unescape them to prevent confusion with existing parsers. For
    example, `type.googleapis.com%2FFoo` should be rejected.
    
    In the original design of `Any`, the possibility of launching a type
    resolution service at these type URLs was considered but Protobuf never
    implemented one and considers contacting these URLs to be problematic and
    a potential security issue. Do not attempt to contact type URLs. */
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type TransportResourceBulkDeleteVendorRes = {
  message?: string;
};
export type TransportResourceBulkUpdateVendorStatusRes = {
  message?: string;
};
export type TransportResourceBulkUpdateVendorStatusReq = {
  ids: string[];
  status: string;
};
export type TransportResourceVendorAddressDetail = {
  id?: string;
  address_name?: string;
  address_category?: string;
  full_address?: string;
  province_id?: string;
  city_id?: string;
  postal_code?: string;
  google_maps_url?: string;
  is_billing_address?: boolean;
  province_name?: string;
  city_name?: string;
};
export type TransportResourceVendorBranchDetail = {
  id?: string;
  branch_name?: string;
  pic_name?: string;
  pic_email?: string;
  pic_phone?: string;
  addresses?: TransportResourceVendorAddressDetail[];
};
export type TransportResourceGetVendorDetailRes = {
  id?: string;
  vendor_name?: string;
  legal_name?: string;
  vendor_code?: string;
  npwp?: string;
  vendor_type?: string;
  status?: string;
  email?: string;
  contact_person_name?: string;
  contact_person_phone_number?: string;
  created_by?: TransportResourceVendorActor;
  updated_by?: TransportResourceVendorActor;
  branches?: TransportResourceVendorBranchDetail[];
  vendor_logo?: string;
};
export type TransportResourceUploadVendorLogoRes = {
  file_url?: string;
  file_name?: string;
  message?: string;
};
export type TransportResourceServiceV1UploadVendorLogoBody = object;
export type TransportResourceVendorMessageRes = {
  message?: string;
};
export type TransportResourceServiceV1CreateVendorAddressBody = {
  branch_id: string;
  address_name: string;
  address_category: string;
  full_address: string;
  province_id: string;
  city_id: string;
  postal_code: string;
  google_maps_url?: string;
  is_billing_address?: boolean;
};
export type TransportResourceServiceV1UpdateVendorAddressBody = {
  branch_id: string;
  address_name: string;
  address_category: string;
  full_address: string;
  province_id: string;
  city_id: string;
  postal_code: string;
  google_maps_url?: string;
  is_billing_address?: boolean;
};
export type TransportResourceServiceV1CreateVendorBranchBody = {
  branch_name: string;
  pic_name: string;
  pic_email: string;
  pic_phone: string;
};
export type TransportResourceServiceV1UpdateVendorBranchBody = {
  branch_name: string;
  pic_name: string;
  pic_email: string;
  pic_phone: string;
};
export type TransportResourceCreateVendorRes = {
  vendor_id?: string;
  vendor_code?: string;
  message?: string;
};
export type TransportResourceCreateVendorBranchAddressItem = {
  address_name: string;
  address_category?: string;
  full_address: string;
  province_id: string;
  city_id: string;
  postal_code: string;
  google_maps_url?: string;
  is_billing_address?: boolean;
};
export type TransportResourceCreateVendorBranchItem = {
  branch_name: string;
  pic_name: string;
  pic_email: string;
  pic_phone: string;
  addresses: TransportResourceCreateVendorBranchAddressItem[];
};
export type TransportResourceCreateVendorReq = {
  vendor_name: string;
  legal_name?: string;
  npwp: string;
  vendor_type: string;
  status: string;
  email: string;
  contact_person_name: string;
  contact_person_phone_number: string;
  branches: TransportResourceCreateVendorBranchItem[];
  vendor_code?: string;
};
export type TransportResourceCreateVendorDraftRes = {
  vendor_id?: string;
  message?: string;
};
export type TransportResourceCreateVendorDraftReq = {
  vendor_name?: string;
  legal_name?: string;
  npwp?: string;
  vendor_type?: string;
  branches?: TransportResourceCreateVendorBranchItem[];
  vendor_code?: string;
  vendor_photo_url?: string;
  email?: string;
  contact_person_name?: string;
  contact_person_phone_number?: string;
};
export type TransportResourceDeleteVendorDraftRes = {
  message?: string;
};
export type TransportResourceUpdateVendorDraftRes = {
  message?: string;
};
export type TransportResourceServiceV1UpdateVendorDraftBody = {
  vendor_name?: string;
  legal_name?: string;
  npwp?: string;
  vendor_type?: string;
  branches?: TransportResourceCreateVendorBranchItem[];
  vendor_code?: string;
  vendor_photo_url?: string;
  email?: string;
  contact_person_name?: string;
  contact_person_phone_number?: string;
};
export type TransportResourcePublishVendorDraftRes = {
  message?: string;
};
export type TransportResourceServiceV1PublishVendorDraftBody = {
  status?: string;
};
export type ApiHttpBody = {
  /** The HTTP Content-Type header value specifying the content type of the body. */
  contentType?: string;
  /** The HTTP request/response body as raw binary. */
  data?: string;
  /** Application specific response metadata. Must be set in the first response
    for streaming APIs. */
  extensions?: ProtobufAny[];
};
export type TransportResourceGetVendorsReq = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  sort_by?: string;
  order?: string;
};
export type TransportResourceExportVendorsReq = {
  format?: string;
  scope?: string;
  ids?: string[];
  filters?: TransportResourceGetVendorsReq;
  sortBy?: string;
  order?: string;
};
export type TransportResourceImportVendorError = {
  row?: number;
  field?: string;
  message?: string;
};
export type TransportResourceImportVendorRes = {
  success?: boolean;
  imported_count?: number;
  message?: string;
  errors?: TransportResourceImportVendorError[];
};
export type TransportResourceUpdateVendorRes = {
  message?: string;
};
export type TransportResourceServiceV1UpdateVendorBody = {
  vendor_name: string;
  legal_name?: string;
  npwp: string;
  vendor_type: string;
  status: string;
  email: string;
  contact_person_name: string;
  contact_person_phone_number: string;
};
export const {
  useTransportResourceServiceV1GetVendorsQuery,
  useTransportResourceServiceV1BulkDeleteVendorMutation,
  useTransportResourceServiceV1BulkUpdateVendorStatusMutation,
  useTransportResourceServiceV1GetVendorDetailQuery,
  useTransportResourceServiceV1UploadVendorLogoMutation,
  useTransportResourceServiceV1CreateVendorAddressMutation,
  useTransportResourceServiceV1DeleteVendorAddressMutation,
  useTransportResourceServiceV1UpdateVendorAddressMutation,
  useTransportResourceServiceV1CreateVendorBranchMutation,
  useTransportResourceServiceV1DeleteVendorBranchMutation,
  useTransportResourceServiceV1UpdateVendorBranchMutation,
  useTransportResourceServiceV1CreateVendorMutation,
  useTransportResourceServiceV1ListVendorDraftsQuery,
  useTransportResourceServiceV1CreateVendorDraftMutation,
  useTransportResourceServiceV1GetVendorDraftQuery,
  useTransportResourceServiceV1DeleteVendorDraftMutation,
  useTransportResourceServiceV1UpdateVendorDraftMutation,
  useTransportResourceServiceV1PublishVendorDraftMutation,
  useTransportResourceServiceV1ExportVendorsMutation,
  useTransportResourceServiceV1ImportVendorMutation,
  useTransportResourceServiceV1DownloadVendorImportTemplateQuery,
  useTransportResourceServiceV1UpdateVendorMutation,
} = injectedRtkApi;
